import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "region";

export const getRegionGlobalList = async (filter: any = {}) => {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: {
				filter: JSON.stringify(filter),
			},
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const getRegionList = (tenantKey: any) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const addRegionItem = (tenantKey: any, data: any) => {
	const _url = tenantKey ? `${url}/${tenantKey}/${apiURL}` : `${url}/${apiURL}`;
	return new Promise((resolve, reject) => {
		axios
			.post(_url, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateRegionItem = (tenantKey: any, uuid: any, data: any) => {
	const _url = tenantKey ? `${url}/${tenantKey}/${apiURL}` : `${url}/${apiURL}`;
	return new Promise((resolve, reject) => {
		axios
			.put(
				_url,
				{
					filter: { uuid: uuid },
					data: data,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteRegionItem = (tenantKey: any, uuid: any) => {
	const _url = tenantKey ? `${url}/${tenantKey}/${apiURL}` : `${url}/${apiURL}`;
	const _filter = tenantKey
		? { filter: { uuid: uuid } }
		: { filter: JSON.stringify({ uuid: uuid }) };
	return new Promise((resolve, reject) => {
		axios
			.delete(_url, {
				params: _filter,
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
